import React from 'react';
import Page from './Page';
import Spacer from './Spacer';
import { PageTitle, Paragraph } from './typography/Typography';

type Props = {
  children: React.ReactNode;
};
type State = {
  hasError: boolean;
};
class DefaultErrorBoundary extends React.Component<Props, State> {
  constructor(props: any) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: any) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error: any, errorInfo: any) {
    // You can also log the error to an error reporting service
    console.warn('Error boundary catch', error);
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <Page>
          <Spacer vertical spacing={5} />
          <PageTitle>Something went wrong...</PageTitle>
          <Spacer vertical spacing={2} />
          <Paragraph>Please let us know at hello@paypi.dev</Paragraph>
        </Page>
      );
    }

    return this.props.children;
  }
}
export default DefaultErrorBoundary;
